import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { Observable } from 'rxjs';
import { MainActions } from '../store/actions';
import { MainPhoneMenu } from '../store/main-phone-state';
import { MainSelectors } from '../store/selectors';

@Injectable({ providedIn: 'root' })
export class PhoneService {
  constructor(private store: Store<MainPhoneMenu>) {}

  loadPhone(baseStoreCode: string): void {
    this.store.dispatch(new MainActions.PhoneLoad(baseStoreCode));
  }

  getPhoneState(): Observable<StateUtils.LoaderState<string>> {
    return this.store.select(MainSelectors.getPhoneState);
  }

  getPhone(): Observable<string> {
    return this.store.select(MainSelectors.getPhoneValue);
  }

  getPhoneLoading(): Observable<boolean> {
    return this.store.select(MainSelectors.getPhoneLoading);
  }

  getPhoneError(): Observable<boolean> {
    return this.store.select(MainSelectors.getPhoneError);
  }

  getPhoneSuccess(): Observable<boolean> {
    return this.store.select(MainSelectors.getPhoneSuccess);
  }
}
